// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    listUneTypes as listUneTypesAPI,
    listUneTouristTypes as listUneTouristTypesAPI,
    listCuisineTypes as listCuisineTypesAPI,
    listClientTypes as listClientTypesAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { uneTypesApiResponseError, uneTypesApiResponseSuccess } from './actions';
import { UneTypesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get uneTypes
 * @param {*} payload - username and password
 */
function* getUneTypes() {
    try {
        const response = yield call(listUneTypesAPI);
        const uneTypes = response.data.data;
        yield put(uneTypesApiResponseSuccess(UneTypesActionTypes.LIST_UNE_TYPES, uneTypes));
    } catch (error) {
        yield put(uneTypesApiResponseError(UneTypesActionTypes.LIST_UNE_TYPES, error));
    }
}

function* getUneTouristTypes() {
    try {
        const response = yield call(listUneTouristTypesAPI);
        const uneTypes = response.data.data;
        yield put(uneTypesApiResponseSuccess(UneTypesActionTypes.LIST_UNE_TOURIST_TYPES, uneTypes));
    } catch (error) {
        yield put(uneTypesApiResponseError(UneTypesActionTypes.LIST_UNE_TOURIST_TYPES, error));
    }
}

function* getCuisineTypes() {
    try {
        const response = yield call(listCuisineTypesAPI);
        const cuisineTypes = response.data.data;
        yield put(uneTypesApiResponseSuccess(UneTypesActionTypes.LIST_CUISINE_TYPES, cuisineTypes));
    } catch (error) {
        yield put(uneTypesApiResponseError(UneTypesActionTypes.LIST_CUISINE_TYPES, error));
    }
}

function* getClientTypes() {
    try {
        const response = yield call(listClientTypesAPI);
        const clientTypes = response.data.data;
        yield put(uneTypesApiResponseSuccess(UneTypesActionTypes.LIST_CLIENT_TYPES, clientTypes));
    } catch (error) {
        yield put(uneTypesApiResponseError(UneTypesActionTypes.LIST_CLIENT_TYPES, error));
    }
}

export function* watchGetUneTypes(): any {
    yield takeEvery(UneTypesActionTypes.LIST_UNE_TYPES, getUneTypes);
}

export function* watchGetUneTouristTypes(): any {
    yield takeEvery(UneTypesActionTypes.LIST_UNE_TOURIST_TYPES, getUneTouristTypes);
}

export function* watchGetCuisineTypes(): any {
    yield takeEvery(UneTypesActionTypes.LIST_CUISINE_TYPES, getCuisineTypes);
}

export function* watchGetClientTypes(): any {
    yield takeEvery(UneTypesActionTypes.LIST_CLIENT_TYPES, getClientTypes);
}

function* uneTypesSaga(): any {
    yield all([
        fork(watchGetUneTypes),
        fork(watchGetUneTouristTypes),
        fork(watchGetCuisineTypes),
        fork(watchGetClientTypes)
    ]);
}

export default uneTypesSaga;
